<template>
    <div class="noBreak">
        <v-btn v-for="(item, i) in availableNavItems"
            color="white"
            icon
            @click="navigate(item)" 
            :key="i"
            :to="{ name: item.route }">
            <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
    </div>
</template>

<script>
import auth from '@/services/auth';

export default {
    components: {
        
    },
    data() {
        return {
            navItems: [
                {
                    icon: "create",
                    text: "Place Order",
                    route: "placeorder"
                },
                {
                    icon: "commute",
                    text: "Assign Suppliers",
                    route: "assignsuppliers"
                }
            ]
        };
    },
    computed: {
        availableNavItems() {
            let routes = this.$router.options.routes;
            let includeRoute = function(routeToCheck){
                for(let i = 0; i < routes.length; i++){
                    let route = routes[i];
                    
                    if(route.name === routeToCheck){
                        return !route.meta || !route.meta.requiredPermissions || auth.hasPermissions(route.meta.requiredPermissions)
                    }
                }

                return false;
            }

            let availableNavItems = [];
            let navItems = this.navItems;

            navItems.forEach(navItem => {
                if(navItem.route){
                    if(includeRoute(navItem.route)){
                        availableNavItems.push(navItem);
                    }
                }
            });

            return availableNavItems;
        }
    },
    methods: {
        navigate(item) {
            this.$router.push({ name: item.route });

            this.$store.commit("generalStore/hideNavDrawer");
        }
    }
};
</script>

<style>
.noBreak {
    white-space: nowrap;
}
</style>
